<template>
  <div>
    <div class="right_header no_flex">
      <div class="right_header_nav" :class='{active: $route.name == "home" || $route.name == "nationDetail"}'>
        <div @click='navClick("province")' class="city_name">{{selectedProvince}}</div>
        <div class="city_list" :class='{show: showProvinceSelecter}'>
          <div @click='toProvinceDetail({name:"全国"})' class="city_item" v-show="selectedProvince!='全国'">全国</div>
          <div @click='toProvinceDetail(item)' class="city_item" v-for='item in provinceList' :key='item.id'>{{item.name}}</div>
        </div>
      </div>
      <div class="right_header_nav" :class='{active: $route.name == "countyList" || $route.name == "countyDetail"}'>
        <div @click='navClick("city")' class="city_name">{{selectedCity}}</div>
        <div class="city_list" :class='{show: showCitySelecter}'>
          <div @click='toCountyList(item)' class="city_item" v-for='item in locationList' :key='item.id'>{{item.name}}</div>
        </div>
      </div>
      <div class="right_header_nav" v-if="isVIP">
        <div @click='navClick("guangdong")' class="city_name">广东数据服务</div>
        <div class="city_list" :class='{show: showGuangdongSelecter}'>
          <router-link class="item city_item" v-for="i in navbar" :key="i.name" :to="i.site">{{i.name}}</router-link>
        </div>
      </div>
      <!-- <div class="right_header_nav_bar" v-if="isVIP">
        <router-link class="item" v-for="i in navbar" :key="i.name" :to="i.site">{{i.name}}</router-link>
      </div> -->
      <div class="right_header_logout pull_right" v-cloak>
        <template v-if="loginStatus == 1">
          <span class="username">{{userName}}</span>
          <a @click='logout' class="logout_btn" href="javascript: void(0)">[退出]</a>
        </template>
        <template v-else-if='loginStatus == 2'>
          <router-link to="/login">登录</router-link>
        </template>
      </div>
    </div>
    <div class="right_content">
      <div class="date_select" v-if='$route.name != "home"'>
        <div class="date_show_zone" @click='showDateSelected'>{{selectedDate}}</div>
        <div class="date_calendar" :class='{show: showDatSelecter}'>
          <div class="date_item" @click='clickDate(item)' v-for='(item, index) in dateList' :class='{selected: selectedDate === item}' :key='index'>{{item}}</div>
        </div>
      </div>
      <Map :list='list' :summary='summary'></Map>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Map from '@/components/Map.vue'
import copy from '@/utils/copy'

export default {
  props: ['list', 'summary'],
  data () {
    return {
      selectedDate: this.$route.query.date || '筛选日期',
      showProvinceSelecter: false,
      showCitySelecter: false,
      showGuangdongSelecter: false,
      showDatSelecter: false,
      navbar: [{
        name: '徐闻菠萝',
        site: '/xvwendata/7211'
      }, {
        name: '阳西荔枝',
        site: '/yangxi/data/8048'
      }, {
        name: '阳西生蚝',
        site: '/yangxi/data/9008'
      }, {
        name: '遂溪火龙果',
        site: '/sxhlg'
      }, {
        name: '梅州柚子',
        site: '/mzyz'
      }, {
        name: '湛江辣椒',
        site: '/zjlj'
      }, {
        name: '徐闻辣椒',
        site: '/xvwendata/8016'
      }, {
        name: '徐闻香蕉',
        site: '/xvwendata/8453'
      }, {
        name: '徐闻韭菜',
        site: '/xvwendata/7991'
      }, {
        name: '徐闻玉米',
        site: '/xvwendata/8534'
      }, {
        name: '广东荔枝',
        site: '/gd_litchi'
      }]
    }
  },
  computed: {
    ...mapState({
      isVIP: state => state.user.isVIP,
      locationList: state => state.right.countyList,
      provinceList: state => state.right.provinceList,
      dateList: state => state.right.dateList,
      selectedProvince: state => state.right.selectedProvince,
      selectedCity: state => state.right.selectedCity,
      userName: state => state.user.userName,
      loginStatus: state => state.user.loginStatus
    })
  },
  mounted () {
    // home主页查询条件 重置广东
    if (parseInt(this.$route.query.province_id, 10) === 20 && this.$route.name === 'home') {
      this.$store.commit('right/setSelectedProvince', '广东')
      this.$store.dispatch('right/getCounty', { provinceId: 20 })
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('user/logout')
    },
    navClick (type) {
      // 未登陆用户，点击后呼出登陆，已登录用户，悬浮出下拉
      if (this.loginStatus === 1) {
        this.hideAllPop()
        if (type === 'city') {
          this.showCitySelecter = !this.showCitySelecter
        } else if (type === 'province') {
          this.showProvinceSelecter = !this.showProvinceSelecter
        } else if (type === 'guangdong') {
          this.showGuangdongSelecter = !this.showGuangdongSelecter
        }
      } else {
        this.$router.push('login')
      }
    },
    // 显示日期选择下拉
    showDateSelected () {
      this.showDatSelecter = !this.showDatSelecter
    },
    // 选择日期
    clickDate (dateStr) {
      if (dateStr) {
        this.selectedDate = dateStr
        const query = copy(this.$route.query)
        query.date = dateStr
        this.$router.push({
          name: this.$route.name,
          params: this.$route.params,
          query: query
        })
        if (this.$route.name === 'nationDetail') {
          this.$store.dispatch('nationDetail/getData', {
            productId: this.$route.params.id,
            date: query.date,
            type: query.type
          })
        } else if (this.$route.name === 'countyList') {
          this.$store.dispatch('county/getData', {
            countyId: this.$route.params.id,
            date: query.date
          })
        } else if (this.$route.name === 'countyDetail') {
          this.$store.dispatch('countyDetail/getData', {
            countyId: this.$route.params.id,
            productId: query.product_id,
            date: query.date,
            type: query.type
          })
        }
      }
      this.hideAllPop()
    },
    // 去省详情
    toProvinceDetail (item = {}) {
      this.$store.commit('right/setSelectedProvince', item.name || '全国')
      this.$store.dispatch('right/getCounty', { provinceId: item.id })
      // if (['home'].indexOf(this.$route.name) > -1) {
      //   this.$store.dispatch('home/getData', {provinceId: item.id})
      // }
      this.$router.push({
        name: 'home',
        query: {
          province_id: item.id
        }
      })
      this.hideAllPop()
    },
    // 去县详情页
    toCountyList (item) {
      this.$store.commit('right/setSelectedCity', item.name || '县市')
      if (this.$route.name === 'countyList') {
        this.$store.dispatch('county/getData', {
          countyId: item.id
        })
      }
      this.$router.push({
        name: 'countyList',
        params: {
          id: item.id
        },
        query: {
          province_id: this.$route.query.province_id
        }
      })
      this.hideAllPop()
    },
    hideAllPop () {
      this.showProvinceSelecter = false
      this.showCitySelecter = false
      this.showGuangdongSelecter = false
      this.showDatSelecter = false
    }
  },
  components: {
    Map
  }
}
</script>

<style lang="less">
.right_header{
  display: flex;
  height: 50px;
  line-height: 50px;
  background: #005582;
}
.right_header.no_flex {
  display: block;
}
.right_header_nav{
  text-decoration: none;
  display: inline-block;
  width: 136px;
  height: 50px;
  position: relative;
  left: 0;
  top: 0;
  font-size: 14px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  vertical-align: top;
  .city_name{
    opacity: 0.6
  }
  &.active{
    .city_name{
      opacity: 1
    }
    background-color: #004970;
    font-size: 16px;
  }
  .city_list{
    position: absolute;
    top: 58px;
    left: 0;
    width: 100%;
    background-color: rgba(40, 48, 63, 0.6);
    color: #fff;
    border-radius: 4px;
    display: none;
    z-index: 99;
    max-height: 520px;
    overflow: auto;
    &.show{
      display: block;
    }
    .city_item{
      display: block;
      text-decoration: none;
      border-radius: 4px;
      color: #fff;
      &:hover{
        background-color: rgba(40, 48, 63, 1);
      }
      &.selected{
        background-color: rgba(40, 48, 63, 1);
      }
    }
  }
}
.right_header_nav_bar {
  display: flex;
  flex: 1;
  margin-right: 32px;
  justify-content: space-around;
  color: #fff;
  .item {
    text-decoration: none;
    color: #fff;
    cursor: pointer;
    font-size: 13px;
  }
}
.right_header_logout{
  font-size: 12px;
  color: #fff;
  text-align: center;
  margin-right: 28px;
  .username{
    opacity: 0.5;
    padding-right: 10px;
  }
  .logout_btn{
    color: #fff;
    text-decoration: none;
  }
  >a{
    color: #fff;
    &:visited{
      color: #fff;
    }
  }
}
.right_content{
  position: relative;
  left: 0;
  top: 0;
}
.date_select{
  position: absolute;
  right: 80px;
  top: 25px;
  z-index: 9;
}
.date_show_zone{
  background-color: #28303F;
  border: none;
  color: #fff;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  padding-left: 30px;
  border-radius: 4px;
  background-image: url(//img.yimutian.com/crm/5bcc2ec56ef1433be54b5deef9e01b9d.png);
  background-repeat: no-repeat;
  background-position: 8px center;
  background-size: auto 15px;
  cursor: pointer;
  width: 120px;
  position: relative;
  left: 0;
  top: 0;
  &:after{
    content: '';
    display: block;
    position: absolute;
    right: 10px;
    top: 56%;
    transform: translateY(-50%) rotate(90deg);
    border: 4px solid transparent;
    border-left: 6px solid #fff;
    z-index: 1;
  }
}
.date_calendar{
  color: #fff;
  background-color: rgba(40, 48, 63, 0.6);
  border-radius: 4px;
  margin-top: 4px;
  text-align: center;
  display: none;
  &.show {
    display: block
  }
  .date_item{
    height: 32px;
    line-height: 32px;
    cursor: pointer;
    border-radius: 4px;
    &:hover{
      background-color: rgba(40, 48, 63, 1);
    }
    &.selected{
      background-color: rgba(40, 48, 63, 1);
    }
  }
}
</style>
